import Discussion from './DiscussionPageServices';
import GroupGlobal from './GroupServices';
import Member from './MemberServices';
export default { Discussion, GroupGlobal, Member };
